<template>
  <div class="home">
    <!-- <NavHeader /> -->
    <Hero />
  </div>
</template>

<script>
// @ is an alias to /src
import NavHeader from "@/components/NavHeader.vue";
import Hero from "@/components/Hero.vue";

export default {
  name: "home",
  components: {
    Hero,
    NavHeader
  }
};
</script>
